import { render, staticRenderFns } from "./WmsAttachment.vue?vue&type=template&id=4104ea53&"
import script from "./WmsAttachment.vue?vue&type=script&lang=js&"
export * from "./WmsAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports